import React from 'react'

import styles from './ProgressBar.module.css'

export type ProgressBarProps = {
  percent: number
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percent }) => (
  <div className={styles.progress}>
    <div className={styles.bar} style={{ width: `${percent}%` }} />
  </div>
)

export { ProgressBar as default, ProgressBar }
